// Shared chart colors used across all charts in the application
// Originally from AnalysisPage, now centralized for consistency

export const SERVICE_COLORS = [
    '#019EE3',
    '#FF5A34',
    '#FEC248',
    '#60419D',
    '#9F9BE8',
    '#058DAD',
    '#25C8FF',
    '#6BB4C5',
    '#CA78D5',
    '#F38F78',
    '#DF0073',
    '#5EAF6C',
    '#78E78B',
    '#4EBFCF',
    '#001B5A',
];

// Helper function to get a color by index with cycling
export const getChartColor = (index: number): string => {
    return SERVICE_COLORS[index % SERVICE_COLORS.length];
};

// Helper function to get colors for an array of items
export const getColorsForItems = (items: string[]): Record<string, string> => {
    const colorMap: Record<string, string> = {};
    items.forEach((item, index) => {
        colorMap[item] = getChartColor(index);
    });
    return colorMap;
};
